export const toKebabCase = (value: string): string =>
  value
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();

export const onlyLetters = (value: string): string => value.replace(/[^\p{L}\s]/gu, '');

const LOWERCASE_CONNECTORS = new Set(['de', 'del', 'la', 'las', 'los', 'el', 'y', 'e', 'en']);

export const toTitleCase = (value: string): string =>
  value
    .toLowerCase()
    .split(/(\s+)/)
    .map((word, index) =>
      index > 0 && LOWERCASE_CONNECTORS.has(word)
        ? word
        : word.replace(
            /(^|[.\-/(])(\p{L})/gu,
            (_, boundary: string, letter: string) => `${boundary}${letter.toUpperCase()}`,
          ),
    )
    .join('');
